var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"countprodotto_upper"},[_c('p',{staticClass:"count_proddoto_upper"},[_vm._v(" "+_vm._s(_vm.prodottoText)+" ("+_vm._s(_vm.countprodotto)+") ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }